/**
 * Event-driven data layer decoupling screen code from Adobe Analytics internals.
 * Components push semantic business events; the adapter translates to GlobalAnalytics calls.
 *
 * Usage:
 *   import dataLayer from '@analytics/dataLayer';
 *   dataLayer.push({ event: 'click', page: { section: 'Product' }, ... });
 */
const listeners = [];
const dataLayer = [];

const originalPush = dataLayer.push.bind(dataLayer);
dataLayer.push = (...items) => {
  const result = originalPush(...items);
  items.forEach((item) => {
    listeners.forEach((fn) => fn(item));
  });
  return result;
};

export const onDataLayerEvent = (fn) => {
  listeners.push(fn);
};

export default dataLayer;
